var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"container"},_vm._l((_vm.shots),function(shot,index){return _c('div',{key:index,style:(_vm.getShotStyle(shot))},[(shot.throwStatus === 'made')?_c('v-icon',{attrs:{"color":"green","size":"24"}},[_vm._v("mdi-check-bold")]):_c('v-icon',{attrs:{"color":"red","size":"24"}},[_vm._v("mdi-close-thick")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }